import { render } from "./LessonFeedCard.vue?vue&type=template&id=c50e5fac&scoped=true"
import script from "./LessonFeedCard.vue?vue&type=script&lang=js"
export * from "./LessonFeedCard.vue?vue&type=script&lang=js"

import "./LessonFeedCard.vue?vue&type=style&index=0&id=c50e5fac&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c50e5fac"]])

export default __exports__